import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import {
  ToolbarButton,
  ToolbarButtonIcon,
} from '../../../../module/ui/components/atoms/rich-text-editor/toolbar/components';
import { ToolBarItemProps } from '../../../../module/ui/components/atoms/rich-text-editor/toolbar/types';

export const EnhanceAINoteButton = ({
  editor,
  afterCommandExecuted,
}: ToolBarItemProps) => {
  return (
    <ToolbarButton
      $active={editor.isActive('enhanceWithMyNotes')}
      icon={<ToolbarButtonIcon icon={faSparkles} />}
      style={{ color: 'var(--purple-60)' }}
      size="small"
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        queueMicrotask(() => {
          editor.chain().focus().enhanceWithMyNotes().run();
          afterCommandExecuted?.();
        });
      }}
    >
      <FormattedMessage id="editor.commands.ask_ai.enhance_with_notes.input.action_label" />
    </ToolbarButton>
  );
};
